import React from 'react';

import { format } from './ErrorFormat';
import { red } from 'utils/style/colors';
import Icon from 'components/Icon';

interface IErrorViewProps {
  err: any;
}

const ErrorView: React.FC<IErrorViewProps> = ({ err, ...rest }) => {
  if (!err) {
    return null;
  }
  const displayText = format(err);
  return (
    <p
      {...rest}
      style={{
        color: red,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Icon type={'info'} className="right" />
      {displayText}
    </p>
  );
};

export default React.memo(ErrorView);
